export const BACKEND_URL = `${process.env.REACT_APP_BACKEND}/api/`;
export const MANUALS_CONTAINER_NAME = process.env.REACT_APP_MANUALS_CONTAINER_NAME || 'manuals';
export const TERMS_CONTAINER_NAME = process.env.REACT_APP_TERMS_CONTAINER_NAME || 'terms';
export const CERTIFICATES_CONTAINER_NAME = process.env.REACT_APP_CERTIFICATES_CONTAINER_NAME || 'certificates';
export const PARTICIPANTS_LIST_CONTAINER_NAME = process.env.REACT_APP_PARTICIPANTS_LIST_CONTAINER_NAME || 'participants';
export const USER_LIST_CONTAINER_NAME = process.env.REACT_APP_USER_LIST_CONTAINER_NAME || 'users';
export const BOOKINGS_LIST_CONTAINER_NAME = process.env.REACT_APP_BOOKINGS_LIST_CONTAINER_NAME || 'bookingslists';
export const INVOICE_CONTAINER_NAME = process.env.REACT_APP_RECEIPT_CONTAINER_NAME || 'invoices';
export const DELIVERY_LIST_CONTAINER_NAME = process.env.REACT_APP_DELIVERY_LIST_CONTAINER_NAME || 'deliveryList';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://quip.eu/';
export const DEVMODE = process.env.REACT_APP_DEVMODE === 'true';
export const STAGING = process.env.REACT_APP_STAGING;

// Quip Customer Center (QCC) URL - the new quip platform. Using 3003 because 3000 and 3001
// are already used by the backend and frontend.
export const QCC_URL = process.env.REACT_APP_QCC_URL || 'https://center.quip.eu';
export const SURVEY_VERSION = 3;
export const LATEST_GT_VERSION = 7;

export function getInvoiceDownloadUrl(fileName, token) {
  const url = `${BACKEND_URL}/Containers/${INVOICE_CONTAINER_NAME}/download/${fileName}`;
  return token ? `${url}?access_token=${token}` : url;
}
